

import CommonApi from './../commonApi';

const tripInspectionFrequency = new CommonApi(
  'tripInspectionFrequency',
  'Периодичность проведения предрейсовых/послерейсовых осмотров'
);

export default {
  ...tripInspectionFrequency
};